// Support article content.
//
// Copy follows ASD-STE100 Simplified Technical English:
// - Use short sentences.
// - Use the active voice.
// - Give one instruction in each sentence.
// - Use the same word for the same thing each time.
//
// To add an article: add an object here. The index page and the article
// page render from this list automatically.

export const SUPPORT_ARTICLES = [
  {
    slug: 'how-to-update-my-plan',
    category: 'Billing',
    title: 'How to update my plan',
    summary: 'Change your Postaway plan from your dashboard settings. Four steps.',
    updated: 'July 21, 2026',
    intro: 'You can change your plan at any time. You do not have to contact support. Use the steps below.',
    steps: [
      {
        title: 'Open Settings',
        text: 'Click your profile photo at the top of the page. A menu opens. Click Settings.',
        image: '/support/update-plan-step-1.png',
        alt: 'The profile menu with the Settings option circled',
      },
      {
        title: 'Open Manage Billing',
        text: 'Click Billing in the left menu. Click the Manage Billing button. The Stripe billing page opens.',
        image: '/support/update-plan-step-2.png',
        alt: 'The Billing tab with the Manage Billing button circled',
      },
      {
        title: 'Click Update subscription',
        text: 'Find your current subscription at the top of the page. Click Update subscription.',
        image: '/support/update-plan-step-3.png',
        alt: 'The Stripe billing page with the Update subscription button circled',
      },
      {
        title: 'Select your new plan',
        text: 'Select the plan that you want. Click Continue. Stripe applies the change to your account.',
        image: '/support/update-plan-step-4.png',
        alt: 'The Stripe plan list with the available plans outlined',
      },
    ],
    outro: 'Your new plan starts immediately. Stripe adjusts the charge for the time that remains in your billing period.',
  },
];

export const getSupportArticle = (slug) =>
  SUPPORT_ARTICLES.find((article) => article.slug === slug) || null;
